import { http } from "./api-config";
import store from "../store";

const apiPeopleClient = http(process.env.VUE_APP_PEOPLE_SERVICE)

export default {
    async getPeopleList(params) {
        const res = await apiPeopleClient.get('peoplelist', {
            params: params != undefined ? params : {}
        })
        return res.data
    },
    async getUserList() {
        let headers = {};
        if (store.state.variables.cashPepleUserList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashPepleUserList', true)
        const res = await apiPeopleClient.get('userslist', { headers })
        return res.data
    },
    async getPeopleById(id) {
        const res = await apiPeopleClient.get(`people/${id}`)
        return res.data
    },
    async createPeople(data) {
        const res = await apiPeopleClient.post('people', data)
        return res.data
    },
    async updatePeople(data) {
        const res = await apiPeopleClient.put('people', data)
        return res.data
    },
    async deletePeople(id) {
        const res = await apiPeopleClient.delete(`people/${id}`)
        return res.data
    },
    async check_email(email) {
        const res = await apiPeopleClient.get(`check_email/${email}`)
        return res.data
    },
    async check_email_attendees(email) {
        const res = await apiPeopleClient.get(`check_email_attendees/${email}`)
        return res.data
    },
    async getDeletedUsersList(userIds) {
        const data = { user_ids: userIds }
        const res = await apiPeopleClient.post('deleteduserslist', data)
        return res.data
    },
}